<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator="/" class="page-breadcrumb">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <!--<el-breadcrumb-item :to="{ path: '/newsList' }">公示详情</el-breadcrumb-item>-->
      <el-breadcrumb-item>动态</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 内容区域 -->
    <div class="card-box">
         <h2 v-text="title" style="text-align: center;color: #0074D9;"></h2>
         <h3 v-text="paper_title2" style="text-align: center;font-size: 1em;"></h3>
    <p v-html="paper"></p>

    </div>
  </div>
</template>

<script>
export default {
  props: ['title','paper_title2','paper'],
  data () {
    return {

    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/paperDetail.vue